import { Hierarchy } from "../models/hierarchy";
import { WhiteLabel } from "../models/white-label";

export class GetHierarchy {
  static execute(): Hierarchy {
    const whiteLabel: WhiteLabel = JSON.parse(sessionStorage.getItem('whiteLabel'));
    return {
      level_one: whiteLabel?.level_one || 'Revenda',
      level_one_gender: whiteLabel?.level_one_gender || 'A',
      level_one_plural: whiteLabel?.level_one_plural || 'Revendas',
      level_two: whiteLabel?.level_two || 'Cliente',
      level_two_gender: whiteLabel?.level_two_gender || 'O',
      level_two_plural: whiteLabel?.level_two_plural || 'Clientes',
    };
  }
}